import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstantsService } from './api-constants.service';
import { Sticker, StickerListParams } from '~core/models/sticker.models';
import { Pagination } from '~core/models/core.models';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class StickerService {
  private readonly _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);
  readonly apiUrl = this._apiConstantsService.stickersUrl;

  list(params?: StickerListParams): Observable<Pagination<Sticker>> {
    return this._http.get<Pagination<Sticker>>(
      this._apiConstantsService.stickersUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  organizationStickers(): Observable<Pagination<Sticker>> {
    return this._http.get<Pagination<Sticker>>(
      this._apiConstantsService.organizationStickersUrl
    );
  }

  readBalance(organizationId: string): Observable<Sticker> {
    return this._http.get<Sticker>(
      `${this._apiConstantsService.stickersUrl}/${organizationId}/read`
    );
  }

  updateAlertLimit(organizationId: string, limit: number): Observable<Sticker> {
    return this._http.patch<Sticker>(
      `${this._apiConstantsService.stickersUrl}/${organizationId}/update`,
      { alertLimitSticker: limit }
    );
  }
}
